<template>
  <div class="video-monitor">
    <div class="section-header">
      <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <rect x="2" y="2" width="20" height="15" rx="2" ry="2"></rect>
        <line x1="8" y1="21" x2="16" y2="21"></line>
        <line x1="12" y1="17" x2="12" y2="21"></line>
      </svg>
      <h3>{{ title }}</h3>
    </div>
    
    <FullMonitorGrid :cameras="cameras" />
  </div>
</template>

<script>
import FullMonitorGrid from './FullMonitorGrid.vue'

export default {
  name: 'VideoMonitor',
  components: {
    FullMonitorGrid
  },
  props: {
    title: {
      type: String,
      default: '视频监控'
    },
    cameras: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped>
.video-monitor {
  background: rgba(26, 54, 93, 0.6);
  border-radius: 12px;
  padding: 16px;
  border: 1px solid rgba(99, 179, 237, 0.2);
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.section-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(99, 179, 237, 0.2);
}

.icon {
  width: 20px;
  height: 20px;
  color: #63b3ed;
}

h3 {
  font-size: 16px;
  font-weight: 600;
  color: #e2e8f0;
  margin: 0;
}
</style>